import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { AuthProvider } from 'context/authContext';
import { HttpProvider } from 'context/httpContext';
import configureStore from 'store/configureStore';
import SnackbarProvider from 'shared/snackbar/Provider';
import reportWebVitals from './reportWebVitals';

import './index.css';
import App from './App';

if (process.env.REACT_APP_SENTRY_DSN) {
	Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, environment: process.env.NODE_ENV });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const store = configureStore();

root.render(
	// React.StrictMode is disabled
	<>
		<HttpProvider>
			<AuthProvider>
				<Provider store={store}>
					<SnackbarProvider maxSnack={3}>
						<App />
					</SnackbarProvider>
				</Provider>
			</AuthProvider>
		</HttpProvider>
	</>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
